import { RecommendationModeSchema } from "@redotech/redo-return-core-common/exchange-agent-guidance/recommendation-mode";
import { ProductDataSchema } from "@redotech/redo-return-operations-common/customer-portal/product";
import * as z from "zod";

const MerchantGuidedProductRecommendationSchema = z.object({
  recommendedProduct: ProductDataSchema,
  recommendedOptions: z.array(
    z.object({ name: z.string(), values: z.array(z.string()) }),
  ),
});

export const MerchantGuidedRecommendationOutputSchema = z
  .object({
    /** @deprecated use recommendations[0].recommendedProduct instead */
    recommendedProduct: ProductDataSchema,
    /** @deprecated use recommendations[0].recommendedOptions instead */
    recommendedOptions: z
      .array(z.object({ name: z.string(), values: z.array(z.string()) }))
      .optional(),
    explanation: z.string().nullish().optional(),
    subtitle: z.string().nullish().optional(),
    outOfStockApology: z.string().nullish(),
    recommendations: z
      .array(MerchantGuidedProductRecommendationSchema)
      .optional(),
    recommendMultipleProducts: z.boolean(),
    recommendationMode: RecommendationModeSchema.optional(),
    agentInput: z.any().optional(),
  })
  .nullable();

export type MerchantGuidedRecommendationOutput = z.infer<
  typeof MerchantGuidedRecommendationOutputSchema
>;
